/** Changes applied FROM the server (merged progress) must not be queued back to it (lib/syncQueue.ts). */
let quiet = 0;
export function quietly<T>(fn: () => T): T {
  quiet++;
  try {
    return fn();
  } finally {
    quiet--;
  }
}
export const isQuiet = () => quiet > 0;
